import { KeyboardEvent } from "react";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useMST4010_R01Store } from "./Store_MST4010_R01";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

interface Props {
	onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchSection_MST4010_R01 = ({ onEnterKeyDown }: Props) => {

	const { compCdList, workPlaceList, eqmTypeList } = useCommonCodeStore();
	const { MST4010_R01Filter, setMST4010_R01Filter } = useMST4010_R01Store();

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={MST4010_R01Filter.compCd}
				onChangeItem={(item) => setMST4010_R01Filter({ compCd: item?.compCd || '' })}
				optionList={compCdList}
			/>
			<SearchDropDownForm
				label="공정"
				value={MST4010_R01Filter.workplaceCd}
				onChangeItem={(item) => setMST4010_R01Filter({ workplaceCd: item?.workplaceCd || '' })}
				optionList={workPlaceList}
			/>
			<SearchDropDownForm
				label="설비유형"
				value={MST4010_R01Filter.equipmentType}
				onChangeItem={(item) => setMST4010_R01Filter({ equipmentType: item?.minorCd || '' })}
				optionList={eqmTypeList}
			/>
			<SearchInputForm
				label="설비코드"
				value={MST4010_R01Filter.equipmentCd}
				onChange={(e) => setMST4010_R01Filter({ equipmentCd: e.target.value })}
				onKeyDown={(e) => { if (e.key === 'Enter') onEnterKeyDown(e); }}
				initValue={() => setMST4010_R01Filter({ equipmentCd: '' })}
			/>
		</SearchSectionForm>
	);
};
